/**
 * The builds a client uses: production, and the one tenant build every
 * isolated tenant cluster serves (`VITE_ENV=tenant`, tenant-image.yml), its
 * staging tenant included, where the client's own people test.
 */
const CLIENT_BUILDS: ReadonlySet<string> = new Set(["prod", "tenant"]);

/**
 * Whether the TanStack Query devtools are mounted: on every environment a
 * client does not use (local, stage), unless the developer turned devtools
 * off with VITE_DISABLE_DEVTOOLS (#8400). Never on production or a tenant
 * cluster: its floating toggle sat over the claims review bar's verdicts for
 * the client's testers (#11422 round 18).
 */
export function shouldMountQueryDevtools(
  env: string | undefined,
  disabled: string | undefined
): boolean {
  return !CLIENT_BUILDS.has(env ?? "") && !disabled;
}
